<app-credit-tier-bar-multiselect
  [clients]="clients$ | async"
  [years]="years$ | async"
  [programs]="programs$ | async"
  [selectedClientId]="selectedClientId$ | async"
  [filters]="filters$ | async"
  [yearsDisabled]="yearsDisabled$ | async"
  [programsDisabled]="programsDisabled$ | async"
  (tierChange)="onTierChange($event)"
  (updateFilters)="onUpdateFilters($event)"
></app-credit-tier-bar-multiselect>
